'use client';

import { useIsProd } from '@/hooks';

type ProdGateProps = {
  children: React.ReactNode;
};

export const ProdGate = ({ children }: ProdGateProps) => {
  const isProd = useIsProd();
  if (isProd) return null;
  return <>{children}</>;
};
